var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from "styled-components";
import { User } from "../User/User";
import React from "react";
export var UserList = styled(function (_a) {
    var users = _a.users, spanProps = __rest(_a, ["users"]);
    return React.createElement("span", __assign({}, spanProps), users === null || users === void 0 ? void 0 : users.map(function (trainerProps) { return React.createElement(User, __assign({ key: trainerProps.id }, trainerProps)); }));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: var(--ws-trainer-column-gap, var(--ws-trainer-gap, .5em));\n    row-gap: var(--ws-trainer-column-gap, var(--ws-trainer-gap, .5em));\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: var(--ws-trainer-column-gap, var(--ws-trainer-gap, .5em));\n    row-gap: var(--ws-trainer-column-gap, var(--ws-trainer-gap, .5em));\n"])));
var templateObject_1;
